export enum TenantFields {
	ID = "id",
	NAME = "name",
	TYPE_ID = "typeId",
	TYPE = "type",
	DESCRIPTION = "description",
	URL = "url",
	HOMOLOGATION = "homologUrl",
	BACKOFFICE = "backofficeUrl"
}

export type TenantProps = {
	[TenantFields.ID]: string;
	[TenantFields.NAME]: string;
	[TenantFields.TYPE]: string;
	[TenantFields.TYPE_ID]?: string;
	[TenantFields.DESCRIPTION]: string;
	[TenantFields.URL]: string;
	[TenantFields.HOMOLOGATION]: string;
	[TenantFields.BACKOFFICE]: string;
};

export enum TenantTypeFields {
	ID = "id",
	NAME = "name",
	DESCRIPTION = "description"
}

export type TenantTypeProps = {
	[TenantTypeFields.ID]: string;
	[TenantTypeFields.NAME]: string;
	[TenantTypeFields.DESCRIPTION]: string;
};

export enum TermFields {
	TERM_TYPE = "termType",
	FILE = "file",
	DATE = "date"
}

export type TermProps = {
	[TermFields.TERM_TYPE]: string;
	[TermFields.FILE]: string;
	[TermFields.DATE]: string;
};
